import React, { useEffect, useState } from 'react';
import Navbar from '../components/NavBar';

const ContactPage = () => {
  const [username, setUsername] = useState('Ziyaretçi');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUsername(payload.username || 'Ziyaretçi');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, []);

  return (
    <>
      <Navbar username={username} />
      <div style={{
        minHeight: 'calc(100vh - 72px)',
        background: 'linear-gradient(to bottom right, #f8fafc, #e2e8f0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 40px',
        gap: '40px',
        flexWrap: 'wrap',
      }}>
        {/* Sol kutu: Metin */}
        <div style={{
          background: 'white',
          padding: '40px 36px',
          borderRadius: '20px',
          boxShadow: '0 12px 30px rgba(0,0,0,0.06)',
          maxWidth: '520px',
          width: '100%',
          fontFamily: 'Segoe UI, sans-serif',
          flex: '1 1 400px',
        }}>
          <h2 style={{
            fontSize: '1.9rem',
            marginBottom: '20px',
            color: '#0f172a',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}>
            <span style={{ fontSize: '1.6rem', color: '#e11d48' }}>📞</span> İletişim
          </h2>

          <p style={{
            fontSize: '1rem',
            marginBottom: '20px',
            color: '#334155',
            lineHeight: 1.6
          }}>
            Tüm sorularınız için bizimle aşağıdaki iletişim kanalları vasıtasıyla görüşebilirsiniz.
          </p>

          <ul style={{
            listStyle: 'none',
            padding: 0,
            fontSize: '1.05rem',
            color: '#1e293b',
            lineHeight: 2,
          }}>
            <li>📧 E-posta: <strong>hvacglobalorg@gmail.com</strong></li>
            <li>📞 Telefon: <strong>+90 534 684 69 35</strong></li>
          </ul>
        </div>

        {/* Sağ kutu: Görsel */}
        <div style={{
          flex: '1.3 1 500px',
          maxWidth: '650px',
          width: '100%',
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
        }}>
          <img
            src="/assets/contact-bg.png"
            alt="Toplantı görseli"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ContactPage;
